import { useEffect, useState } from "react";

interface BrowserInfo {
  timezone: string;
  language: string;
  platform: string;
  browserName: string;
  isMobile: boolean;
}

export default function useBrowserInfo(): BrowserInfo {
  const [info, setInfo] = useState<BrowserInfo>({
    timezone: "",
    language: "",
    platform: "",
    browserName: "",
    isMobile: false,
  });

  useEffect(() => {
    const { userAgent, language } = navigator;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const platform =
      (navigator as any).userAgentData?.platform || navigator.platform;

    let browserName = "Unknown";

    if (/edg/i.test(userAgent)) {
      browserName = "Edge";
    } else if (/opr\//i.test(userAgent) || /opera/i.test(userAgent)) {
      browserName = "Opera";
    } else if (/chrome|crios|crmo/i.test(userAgent)) {
      browserName = "Chrome";
    } else if (/firefox|fxios/i.test(userAgent)) {
      browserName = "Firefox";
    } else if (/safari/i.test(userAgent) && !/chrome/i.test(userAgent)) {
      browserName = "Safari";
    }

    const isMobile = (() => {
      if ((navigator as any).userAgentData?.mobile !== undefined) {
        return (navigator as any).userAgentData.mobile;
      }

      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );
    })();

    setInfo({
      timezone,
      language,
      platform,
      browserName,
      isMobile,
    });
  }, []);

  return info;
}
